import { edkt, PageView } from '@airgrid/edgekit';
import { SequenceEntry, SequenceAnalyticsResult } from 'ts-types';

export class SequenceAnalytics {
  loadId: string;
  pageViews: PageView[];
  previousSampledLoadId: string | null;
  matchedAudienceIds: string[];

  static SAMPLED_LOAD_ID_KEY = 'edkt_sampled_load_id';
  static MATCHED_AUDIENCE_IDS_KEY = 'edkt_matched_audience_ids';
  static MIN_SEQUENCE_LENGTH = 8;
  static SAMPLE_RATE = 1 / 256;

  constructor(loadId: string) {
    this.loadId = loadId;
    this.pageViews = edkt.getCopyOfPageViews();
    this.previousSampledLoadId = SequenceAnalytics._getPreviousSampledLoadId();
    this.matchedAudienceIds = SequenceAnalytics._loadMatchedAudienceIds();
  }

  static _getPreviousSampledLoadId(): SequenceAnalytics['loadId'] | null {
    const loadId = localStorage.getItem(this.SAMPLED_LOAD_ID_KEY);
    if (!loadId) return null;
    return loadId;
  }

  static _loadMatchedAudienceIds(): string[] {
    const audiences = localStorage.getItem(this.MATCHED_AUDIENCE_IDS_KEY);
    if (!audiences) return [];
    return JSON.parse(audiences);
  }

  static _setLastSampledLoadId(loadId: SequenceAnalytics['loadId']): void {
    localStorage.setItem(this.SAMPLED_LOAD_ID_KEY, loadId);
  }

  static _includeInSample(): boolean {
    return Math.random() < this.SAMPLE_RATE;
  }

  _createSequence(): SequenceEntry[] {
    return this.pageViews
      .filter((view) => {
        return !!(view.ts && view.kh && typeof view.kh !== 'undefined');
      })
      .map((view) => {
        const { ts, kh } = view;
        return { ts, kh, tr: null };
      });
  }

  get(toSequence: boolean): SequenceAnalyticsResult | undefined {
    if (
      !toSequence &&
      this.pageViews.length <= SequenceAnalytics.MIN_SEQUENCE_LENGTH
    )
      return undefined;

    if (toSequence || SequenceAnalytics._includeInSample()) {
      SequenceAnalytics._setLastSampledLoadId(this.loadId);
      return {
        sl: this.previousSampledLoadId,
        sq: this._createSequence(),
        ma: this.matchedAudienceIds,
      };
    }

    return undefined;
  }
}
